
import React from 'react';
import { GROUP } from '../../CompanyInfo';
import Footer from '../../Footer';
import { useHistory } from 'react-router-dom';
import '../../App.css';
import { Container, Nav, NavDropdown, Navbar, Offcanvas } from 'react-bootstrap';
import AboutUs from '../AboutUs/AboutUs';
import ContactUs from '../ContactUs/ContactUs';
import OurVision from '../OurVision/OurVision';
import OurValues from '../OurValues/OurValues';
import { useEffect } from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import HomeComponent from './components/HomeComponent';
import './css/home.css';
import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy';


function Home(props) {

    const pageName = props && props.match && props.match.params && props.match.params.pageName;
    // console.log(pageName);
    const history = useHistory();

    const [currentComponent, setCurrentComponent] = useState(pageName);
    // Controlled so tapping a link closes the burger menu on mobile.
    const [navOpen, setNavOpen] = useState(false);

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash.substr(1);
            setCurrentComponent(hash || 'Home');
        };

        window.addEventListener('hashchange', handleHashChange);
        handleHashChange();

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    const renderComponent = useCallback(() => {
        // console.log({ currentComponent });
        switch (currentComponent) {
            case 'AboutUs':
                return <AboutUs />;
            case 'OurVision':
                return <OurVision />;
            case 'OurValues':
                return <OurValues />;
            case 'ContactUs':
                return <ContactUs />;
            case 'PrivacyPolicy':
                return <PrivacyPolicy />;
            default:
                return <HomeComponent />;
        }
    }, [currentComponent]);

    const handleNavLinkClick = (component) => {
        history.push("#" + component);
        setCurrentComponent(component);
        setNavOpen(false);
    };

    const NAV_ITEMS = [
        { key: 'Home', label: 'Home' },
        { key: 'AboutUs', label: 'About Us' },
        { key: 'OurVision', label: 'Our Vision' },
        { key: 'OurValues', label: 'Our Values' },
        { key: 'PrivacyPolicy', label: 'Privacy Policy' },
        { key: 'ContactUs', label: 'Contact Us' },
    ];

    const goLogin = (path) => {
        setNavOpen(false);
        history.push(path);
    };

    const isActive = (key) =>
        key === 'Home'
            ? currentComponent === 'Home' || currentComponent === 'home'
            : currentComponent === key;



    return (
        <>

            <div className='siteHeader'>
                <div className='siteHeaderInner'>
                    <img src={GROUP.logo} className='siteLogo' alt={GROUP.name} />
                    <div className='siteBrandText'>
                        <h1 className='siteName'>{GROUP.name}</h1>
                        <p className='siteSince'>{GROUP.since}</p>
                    </div>
                    {/* an empty cell the width of the logo column, so the text
                        is centred on the band and the logo stays on the left */}
                    <span className='siteHeaderSpacer' aria-hidden='true' />
                </div>
            </div>

            {/* Layout is all CSS media queries now. It used to read
                window.innerWidth during render, which never re-ran on resize or
                rotation, and set position:false - not a valid CSS value. */}
            {/* Navbar.Offcanvas renders a real sidebar drawer below the `lg`
                breakpoint and a plain inline bar above it. Layout is all CSS
                media queries: the old code read window.innerWidth during
                render, which never re-ran on resize or rotation, and set
                position:false - not a valid CSS value. */}
            <Navbar
                expand="lg"
                sticky="top"
                className='siteNav'
                expanded={navOpen}
                onToggle={setNavOpen}
            >
                <Container fluid className='siteNavInner'>
                    <Navbar.Toggle aria-controls="mainNav" aria-label="Open menu" />

                    {/* On a phone the bar holds nothing but the toggler, which
                        read as a tall empty band. */}
                    <span className='siteNavCurrent d-lg-none'>
                        {(NAV_ITEMS.find((i) => isActive(i.key)) || {}).label ||
                            'Menu'}
                    </span>

                    <Navbar.Offcanvas
                        id="mainNav"
                        aria-labelledby="mainNavLabel"
                        placement="start"
                        className='siteDrawer'
                        onHide={() => setNavOpen(false)}
                    >
                        <Offcanvas.Header closeButton closeVariant='white'>
                            <Offcanvas.Title id="mainNavLabel" className='siteDrawerTitle'>
                                <img src={GROUP.logo} className='siteDrawerLogo' alt="" />
                                {GROUP.name}
                            </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                            <Nav className='siteLinks me-auto'>
                                {NAV_ITEMS.map((item) => (
                                    <Nav.Link
                                        key={item.key}
                                        className={isActive(item.key) ? 'activeLink' : ''}
                                        onClick={() => handleNavLinkClick(item.key)}
                                    >
                                        {item.label}
                                    </Nav.Link>
                                ))}
                                {/* Product List has moved behind the customer
                                    login - see components/customer/HeaderCustomer. */}
                            </Nav>

                            {/* In the sidebar the two logins are direct items:
                                a dropdown nested in a drawer is awkward to tap
                                and its floating menu fights the drawer. The
                                dropdown is kept for the desktop bar. */}
                            <Nav className='siteLoginNav d-lg-none'>
                                <div className='siteLoginLabel'>Login As</div>
                                <Nav.Link onClick={() => goLogin("/Login/Customer")}>
                                    Customer
                                </Nav.Link>
                                <Nav.Link onClick={() => goLogin("/Login/Company")}>
                                    Company
                                </Nav.Link>
                            </Nav>

                            <Nav className='siteLoginNav d-none d-lg-flex'>
                                <NavDropdown
                                    title="Login As"
                                    align="end"
                                    id="loginAsDropdown"
                                    className='loginAsDropdown'
                                >
                                    <NavDropdown.Item onClick={() => goLogin("/Login/Customer")}>
                                        Customer
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item onClick={() => goLogin("/Login/Company")}>
                                        Company
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>

            <div className='middle'
            // style={{
            //     minHeight: window.innerHeight / 1.4
            // }}
            >

                {renderComponent()}


            </div>
            <Footer />


        </>
    )
}
export default Home